module.exports = __webpack_public_path__ + "img/free-standing-wall-2.2a8ffc7a.jpeg";